import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const WorkspaceCtx = createContext(null);

export function WorkspaceProvider({ children }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [currentId, setCurrentId] = useState(() => localStorage.getItem("workspace_id") || "");
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const ws = await api.listWorkspaces();
      setWorkspaces(ws);
      if (!currentId && ws.length) {
        const def = ws.find(w => w.is_default) || ws[0];
        setCurrentId(def.id);
        localStorage.setItem("workspace_id", def.id);
      } else if (currentId && !ws.find(w => w.id === currentId) && ws.length) {
        setCurrentId(ws[0].id);
        localStorage.setItem("workspace_id", ws[0].id);
      }
    } finally { setLoading(false); }
  }, [currentId]);

  useEffect(() => { reload(); /* eslint-disable-next-line */ }, []);

  const switchTo = (id) => {
    setCurrentId(id);
    localStorage.setItem("workspace_id", id);
  };

  const current = workspaces.find(w => w.id === currentId) || workspaces[0];

  return (
    <WorkspaceCtx.Provider value={{ workspaces, current, currentId, switchTo, reload, loading }}>
      {children}
    </WorkspaceCtx.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceCtx) || { workspaces: [], current: null, currentId: "", switchTo: () => {}, reload: () => {}, loading: false };
